import React, {useState, useEffect} from 'react'
import {JobCategoryData} from '../../datas/TrainersData'
import { Link, useLocation } from 'react-router-dom'
import TrainerCard from '../../components/Cards/TrainerCard.js'
import InputIcon from '../../../components/Form/InputIcon'
import Select from '../../../components/Form/Select'
import bookmaker from '../../assets/icons/bookmaker-svgrepo-com.svg'
import Checkbox from '../../../components/Form/Checkbox/index.jsx'
import SecteurEntreprise from "../../datas/SecteurEntreprise.json"
import search from "../../assets/searchIcon/search.svg"
import location from "../../assets/searchIcon/location.svg"
import category from "../../assets/searchIcon/category.svg"
import back11 from '../../assets/images/49eddec5-17f2-4a0c-b7ca-5ece838b0848.jpg'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTrainers } from '../../../redux/trainerSlice.js'
import SelectIcon from '../../../components/Form/SelectIcon'
import { Pagination } from "react-headless-pagination";
import { CgArrowLeft, CgArrowRight } from 'react-icons/cg'
import RowPagination from "../../components/Pagination"

const FindTrainers = () => {

  const dispatch = useDispatch();    
  const  {pathname} = useLocation()
  const { trainers, loading, error } = useSelector((state) => state.trainer);
  const [filters, setFilters] = useState({
    keyword: '',
    localisation: '',
    category: '',
    page: 1,
  });

  const handlePageChange = (newPage) => {
    console.log("page selected", newPage)
    setFilters((prev) => ({
      ...prev,
      page: newPage+2,
    }));
  };

  useEffect(() => {
    dispatch(fetchTrainers({
      location: filters.localisation,
      category: filters.category,
      keyword: filters.keyword,
      page: filters.page,
      limit: 10,
    })); 
  }, [filters.page]); // Dépend uniquement de filters.page

  // useEffect(() => {
  //   if(page){
  //     dispatch(fetchTrainers({location:"", category:"", keyword : "", page: currentPage, limit : 10})); 
  //   }
    
  // }, [currentPage])

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const response = await dispatch(fetchTrainers({
  //       location: filters.localisation,
  //       category: filters.category,
  //       keyword: filters.keyword,
  //       page: filters.page,
  //       limit: 10
  //     }));
  
  //     if (response.payload && response.payload.total_pages) {
  //       setTotalPages(response.payload.total_pages);
  //     }
  //   };
  
  //   fetchData();
  // }, [filters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
    
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFilters((prev) => ({ ...prev, [name]: value }));
  // };

    return (
      <div className=''>
        <div className="bg-purple-300 h-56 w-full p-responsive py-8"  style={{ backgroundImage: `url(${back11})`, objectFit: "cover" }}>
          <div className="flex justify-between mb-10">
          <h5 className='font-semibold text-lg'>Formateur</h5>
          <li className="flex gap-x-2 text-sm items-center">
            <ul className="text-gray-600"> <Link to="/home">Accueil</Link>  / </ul>
            <ul className="font-medium">Emploi</ul>
          </li>
          </div>

          <div className="bg-white rounded-lg shadow h-16 p-2">
        {/* <div className="grid lg:grid-cols-7 sm:grid-cols-5 grid-cols-3">
          <InputIcon 
          className='col-span-2'
          name="keyword" 
          value={filters.keyword} 
          placeholder='Offre, poste, mot clé ...' 
          noBorder={true} 
          onChange={handleInputChange}
          />
            <InputIcon 
            className='col-span-2 hidden sm:block'
            value={filters.localisation} 
            icon={location} 
            name="localisation" 
            placeholder='Localisation' 
            noBorder={true} 
            onChange={handleInputChange}/>
          <div className="grid  gap-x-2">
            <button onClick={()=>dispatch(fetchTrainers(filters))} className="p-4 py-3 bg-black rounded-md text-white font-medium">
              Rechercher
            </button>
          </div>
        </div> */}

          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-2">
                    <div className=" col-span-3 w-full grid grid-cols-2">
                    <InputIcon
                      name="keyword"
                      placeholder="Mot clé ..."
                      noBorder={true}
                      value={filters.keyword}
                      onChange={handleInputChange}
                    />
                    <InputIcon
                      className="hidden xl:block"
                      name="location"
                      placeholder="Localisation"
                      value={filters.location}
                      icon={location}
                      noBorder={true}
                      onChange={handleInputChange}
                    />
                    </div>
                    <div className="flex items-center gap-x-2 gap-y-2">
                      <button onClick={()=>{                 
                        dispatch(fetchTrainers({   
                          location: filters.location,
                          keyword: filters.keyword,
                          page: 1,
                          limit: 10,
                        }))
                        }} className="p-4 py-3 bg-black rounded-md text-white font-medium w-full">
                        Rechercher
                      </button>
                    </div>
                  </div>
      </div>
            
        </div>

        <div className="bg-white px-6 lg:px-20 xl:px-40 h-16 shadow-sm -6 py-3">
        <div className="flex justify-between items-center">
          <div className="flex gap-2 items-center"> 
          <span className="text-lg font-semibold"> {trainers?.total} Résultats </span>
          </div>

          <div className="flex gap-2 items-center"> 
          <span>Par page </span>
          <Select name="limit" className="w-40" options={["10", "15","30"]} mb='0' onChange={(e)=>setFilters({...filters, limit: e.target.value})}/> 
        </div>
          
         
        </div>
      </div>

        <div className="flex-1 p-responsive mt-10">
          <div className="flex gap-x-6">
            <div className="flex-1 ">
                <div className='grid grid-cols-1 lg:grid-cols-2  gap-6'>
                {trainers?.data?.map((item, index)=>{
                    return( 
                      <TrainerCard key={index} item={item} />
                      )
                    })}
                    </div>
            
            </div>

   
    </div>
    <RowPagination
    currentPage={filters?.page || 1}
    setCurrentPage={handlePageChange}
    totalPages={trainers?.last_page}
    />
    {/* <div className="mt-10 pt-6 border-t">
    <Pagination
        currentPage={filters?.page || 1}
        setCurrentPage={handlePageChange}
        totalPages={trainers?.last_page || 10} // Récupérer le total depuis l'API
        edgePageCount={2}
        middlePagesSiblingCount={2}
        className="flex items-center gap-2 p-2"
        truncableText="..."
        truncableClassName="text-gray-500"
      >
        <Pagination.PrevButton className="px-4 py-2.5 border rounded-md hover:bg-gray-100 transition">
          <CgArrowLeft />
        </Pagination.PrevButton>

        <div className="flex items-center justify-center flex-grow gap-2 list-none">
          <Pagination.PageButton
            activeClassName="bg-gray-950 text-white"
            inactiveClassName="bg-white text-gray-700 border-gray-300 hover:bg-gray-200"
            className="px-4 py-2 border rounded-md transition cursor-pointer"
          />
        </div>

        <Pagination.NextButton className="px-4 py-2.5 border rounded-md hover:bg-gray-100 transition">
          <CgArrowRight />
        </Pagination.NextButton>
      </Pagination>

    </div> */}
  </div>
      </div>
    )
  }
  
export default FindTrainers